module.exports = __webpack_public_path__ + "static/media/Segment6.9c2e50aa.jpg";